

























































import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import {$} from '../facade'
import InvocationNetworkCard from '@/components/InvocationNetworkCard.vue'
import NetworkTag from '@/components/NetworkTag.vue'
import {ShrikeHelper, ShrikeN3StatisticsResponse} from '@/helpers/ShrikeHelper'

@Component({
  components: {NetworkTag, InvocationNetworkCard},
  computed: {
    $() {
      return $
    },
  },
})
export default class InvocationNetworkCards extends Vue {
  @Prop({required: true, type: String}) selectedNetwork!: string

  contractsTodayValue: string = '-'
  contractsWeekValue: string = '-'
  contractsMonthValue: string = '-'
  contractsAllTimeValue: string = '-'
  contractsTodayPercentage: number = 0
  contractsWeekPercentage: number = 0
  contractsMonthPercentage: number = 0
  contractsAllTimePercentage: number = 0

  addressesTodayValue: string = '-'
  addressesWeekValue: string = '-'
  addressesMonthValue: string = '-'
  addressesAllTimeValue: string = '-'
  addressesTodayPercentage: number = 0
  addressesWeekPercentage: number = 0
  addressesMonthPercentage: number = 0
  addressesAllTimePercentage: number = 0

  invocationsTodayValue: string = '-'
  invocationsWeekValue: string = '-'
  invocationsMonthValue: string = '-'
  invocationsAllTimeValue: string = '-'
  invocationsTodayPercentage: number = 0
  invocationsWeekPercentage: number = 0
  invocationsMonthPercentage: number = 0
  invocationsAllTimePercentage: number = 0

  mounted() {
    this.populateN3Statistics()
  }

  @Watch('selectedNetwork')
  onSelectedNetworkChange() {
    this.populateN3Statistics()
  }

  private formatCount(value: number) {
    return value.toLocaleString('en-US')
  }

  private percentChange(current: number, previous: number) {
    if (previous <= 0) return current > 0 ? 100 : 0
    return Math.round(((current - previous) / previous) * 100)
  }

  private resetValues() {
    this.contractsTodayValue = '-'
    this.contractsWeekValue = '-'
    this.contractsMonthValue = '-'
    this.contractsAllTimeValue = '-'
    this.contractsTodayPercentage = 0
    this.contractsWeekPercentage = 0
    this.contractsMonthPercentage = 0
    this.contractsAllTimePercentage = 0

    this.addressesTodayValue = '-'
    this.addressesWeekValue = '-'
    this.addressesMonthValue = '-'
    this.addressesAllTimeValue = '-'
    this.addressesTodayPercentage = 0
    this.addressesWeekPercentage = 0
    this.addressesMonthPercentage = 0
    this.addressesAllTimePercentage = 0

    this.invocationsTodayValue = '-'
    this.invocationsWeekValue = '-'
    this.invocationsMonthValue = '-'
    this.invocationsAllTimeValue = '-'
    this.invocationsTodayPercentage = 0
    this.invocationsWeekPercentage = 0
    this.invocationsMonthPercentage = 0
    this.invocationsAllTimePercentage = 0
  }

  private applyStats(data: ShrikeN3StatisticsResponse['data']) {
    this.contractsAllTimeValue = this.formatCount(data.contracts.total)
    this.contractsTodayValue = this.formatCount(data.contracts.today)
    this.contractsWeekValue = this.formatCount(data.contracts.this_week)
    this.contractsMonthValue = this.formatCount(data.contracts.this_month)
    this.contractsTodayPercentage = this.percentChange(
      data.contracts.today,
      data.contracts.yesterday
    )
    this.contractsWeekPercentage = this.percentChange(
      data.contracts.this_week,
      data.contracts.last_week
    )
    this.contractsMonthPercentage = this.percentChange(
      data.contracts.this_month,
      data.contracts.last_month
    )

    this.addressesAllTimeValue = this.formatCount(data.addresses.total)
    this.addressesTodayValue = this.formatCount(data.addresses.today)
    this.addressesWeekValue = this.formatCount(data.addresses.this_week)
    this.addressesMonthValue = this.formatCount(data.addresses.this_month)
    this.addressesTodayPercentage = this.percentChange(
      data.addresses.today,
      data.addresses.yesterday
    )
    this.addressesWeekPercentage = this.percentChange(
      data.addresses.this_week,
      data.addresses.last_week
    )
    this.addressesMonthPercentage = this.percentChange(
      data.addresses.this_month,
      data.addresses.last_month
    )

    this.invocationsAllTimeValue = this.formatCount(data.invocations.total)
    this.invocationsTodayValue = this.formatCount(data.invocations.today)
    this.invocationsWeekValue = this.formatCount(data.invocations.this_week)
    this.invocationsMonthValue = this.formatCount(data.invocations.this_month)
    this.invocationsTodayPercentage = this.percentChange(
      data.invocations.today,
      data.invocations.yesterday
    )
    this.invocationsWeekPercentage = this.percentChange(
      data.invocations.this_week,
      data.invocations.last_week
    )
    this.invocationsMonthPercentage = this.percentChange(
      data.invocations.this_month,
      data.invocations.last_month
    )
  }

  private async populateN3Statistics() {
    // Network cards use Shrike N3 aggregates only; Neo X tab has no stats feed yet.
    if (this.selectedNetwork !== 'n3') {
      this.resetValues()
      return
    }

    try {
      const res = await ShrikeHelper.getN3Statistics()
      this.applyStats(res.data)
    } catch (e) {
      // fail-soft: keep UI usable even if Shrike is down locally
      this.resetValues()
      // eslint-disable-next-line no-console
      console.error('Failed to fetch n3 statistics', e)
    }
  }
}
